enum ActionName {
    TRANSPORTATION_STATUS_UPDATE = 'TransportationStatusUpdate',
    TRANSPORTATION_PARCELS_PREVIEW = 'TransportationParcelsPreview',
    TRANSPORTATION_LOAD_UNITS_PREVIEW = 'TransportationLoadUnitsPreview',
    PARCEL_TRACKING_INPUT = 'ParcelTrackingInput'
}

export default ActionName;
